import * as React from 'react';
import { isValidDurationString, parseDurationInput } from '@/common/utils/estimates/durations';
import { formatSecondsToHours } from '@/common/utils/formatSecondsToHours';

export const useDurationFieldInput = ({
  committedSeconds,
  onCommit,
}: {
  committedSeconds: number | null;
  onCommit: (seconds: number | null) => void;
}) => {
  const [value, setValue] = React.useState(
    committedSeconds != null ? formatSecondsToHours(committedSeconds) : '',
  );

  React.useEffect(() => {
    setValue(committedSeconds != null ? formatSecondsToHours(committedSeconds) : '');
  }, [committedSeconds]);

  const commit = (): boolean => {
    const trimmed = value.trim();
    if (trimmed !== '' && !isValidDurationString(trimmed)) {
      return false;
    }

    const nextSeconds = trimmed === '' ? null : parseDurationInput(trimmed);
    if (nextSeconds !== committedSeconds) {
      onCommit(nextSeconds);
    }
    return true;
  };

  return { value, setValue, commit };
};
